export default `
  <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MR7CQ6J"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
`;
